import { render } from "./FriendCard-InviteSent.vue?vue&type=template&id=a469a06c&scoped=true"
import script from "./FriendCard-InviteSent.vue?vue&type=script&lang=js"
export * from "./FriendCard-InviteSent.vue?vue&type=script&lang=js"

import "./FriendCard-InviteSent.vue?vue&type=style&index=0&id=a469a06c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a469a06c"]])

export default __exports__